export default __webpack_public_path__ + "static/HammersmithOne-Regular-e6f8b2906b5856aebe23d157dbba5008.ttf";